<template>
  <div class="page-five">
    <header class="profile-header">
      <video poster="@/assets/linda.png"
        ref="videoPlayer"
        class="profile-video"
        playsinline
        webkit-playsinline
      >
        <source src="@/assets/Linda.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <button class="play-button" @click="startVideo">
        <img src="@/assets/play-button.png" alt="Play Video" />
      </button>
      <!-- Large "L" -->
      <div class="large-l">L</div>
      <div class="brand-logo">BERNARDUS</div>

      <!-- White Block at the Bottom -->
      <div class="white-block">
        <p class="white-block-text">
          PAGE 5 Good to see you! My name is Linda, L’s avatar across the globe. I can take any shape or form, but regardless of what I look like and which language I speak, <strong>I want to personally welcome you as the latest member of the Founders Family.</strong>
        </p>
      </div>
    </header>

    <!-- Actions -->
    <section class="actions">
      <button class="download-button" @click="goToNextPage">Tap to continue!</button>
    </section>
  </div>
</template>

<script>
export default {
  name: "Linda_page5",
  data() {
    return {
      isPlaying: false, // Indicates if the video is playing
    };
  },
  methods: {
    goToNextPage() {
      this.$router.push('/page-six'); // Navigates to VideoPageLinda2
    },
    startVideo() {
      const video = this.$refs.videoPlayer;
      if (video) {
        if (this.isPlaying) {
          video.pause();
        } else {
          video.play();
        }
        this.isPlaying = !this.isPlaying; // Toggle the playback state
      }
    },
  },
};
</script>

<style scoped>
/* General Page Styling */
/* Profile Header */
.profile-header {
  position: relative;
  width: 100%;
  height: auto;
}

.profile-video {
  width: 100%;
  object-fit: cover;
}

/* White Block Styling */
.white-block {
  position: absolute;
  bottom: 0;
  left: 0;
  width: calc(100% - 20px); /* Width ends 20px before the right edge */
  right: 20px; /* Offset the white block 20px from the right */
  background-color: #fff;
  padding: 20px;
  /* box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1); */
  text-align: left;
}

.white-block-text {
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
  color: #333;
}

.white-block-text strong {
  font-weight: bold;
}

.white-block-action {
  margin-top: 10px;
  font-size: 0.9rem;
  color: #666;
  display: flex;
  align-items: center;
}

.white-block-action .icon {
  font-size: 1rem;
  margin-right: 5px;
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: none; /* Remove background color */
  border: none; /* Remove default border */
  cursor: pointer;
  padding: 0; /* Remove default padding */
  width: 60px; /* Adjust button size based on your image dimensions */
  height: 60px;
}

.play-button img {
  width: 75%; /* Make the image fill the button */
  height: 75%;
  object-fit: contain; /* Ensure the image maintains its aspect ratio */
}

/* Large "L" Styling */
.large-l {
  position: absolute;
  left: -4px; /* Place it slightly inset from the left of the white block */
  font-size: 6rem; /* Adjust size as needed */
  font-weight: bold;
  color: #fff;
  margin-top: -250px;
}
</style>
